/** Shared API base URL for HTTP clients and OAuth popup flows. */
export function getApiBaseUrl(): string {
  return (
    import.meta.env.VITE_API_BASE_URL ||
    import.meta.env.VITE_API_URL ||
    'http://localhost:4000'
  );
}
